export default __webpack_public_path__ + "static/media/artboard4.7cfcd4bb.png";